module.exports = __webpack_public_path__ + "img/red-virus.988b73dc.png";